import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { ProviderEnum } from '@/types/common';
import { AdyenCard3DSForm } from './AdyenCard3DSForm';
import { StripeCard3DSForm } from './StripeCard3DSForm';
import { ForterCard3DSForm } from './ForterCard3DSForm';

export const Card3DSForm = () => {
  const {
    threeDSSecurityState: { provider, show3DSForm, managedOrderToken },
  } = useContext(CheckoutContext);
  if (!show3DSForm) return null;

  // Forter-orchestrated 3DS is provider-agnostic and takes precedence over the
  // PSP-native drivers, so it's checked before the `provider` gate below.
  if (managedOrderToken) {
    return <ForterCard3DSForm />;
  }

  if (!provider) return null;

  if (provider === ProviderEnum.ADYEN) {
    return <AdyenCard3DSForm />;
  }

  if (provider === ProviderEnum.STRIPE) {
    return <StripeCard3DSForm />;
  }

  return null;
};
